export default {
  bookmarkGroups: [],
  bookmarkPage: {},
};
